import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.computeEta()
  }

  computeEta() {
    const started = new Date(this.element.dataset.etaStarted)
    const current = parseInt(this.element.dataset.etaCurrent, 10)
    const total = parseInt(this.element.dataset.etaTotal, 10)

    if (!started || !current || !total || current >= total) {
      this.timeTarget.textContent = "—"
      return
    }

    const elapsedMs = Date.now() - started.getTime()
    if (elapsedMs <= 0) {
      this.timeTarget.textContent = "calculating..."
      return
    }

    const rate = current / (elapsedMs / 1000)
    const remainingSec = (total - current) / rate

    const eta = new Date(Date.now() + remainingSec * 1000)
    const formatted = eta.toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short"
    })

    const mins = Math.ceil(remainingSec / 60)
    const duration = mins >= 60
      ? `~${Math.floor(mins / 60)}h ${mins % 60}m`
      : `~${mins}m`

    this.timeTarget.textContent = `${formatted} (${duration} remaining)`
  }
}
